export default "__VITE_ASSET__H6yfxcKd__"